import React from 'react';
import { Alert, Form } from 'react-bootstrap';
import { useTenants } from '../../hooks/tenants/useTenants';
import { ParkingQueueEntry } from '../../types/parkingQueue';

interface Props {
    /** The entries ahead; nothing is rendered while null or empty. */
    ahead: ParkingQueueEntry[] | null;
    reason: string;
    onReasonChange: (reason: string) => void;
    /** Validation message for the reason, shown once the user tried to save. */
    error?: string;
    idPrefix: string;
}

/** "N sökande står före …" and the required Anledning, for both lease flows. */
const DeviationNotice: React.FC<Props> = ({ ahead, reason, onReasonChange, error, idPrefix }) => {
    const { getTenantName } = useTenants();
    if (!ahead || ahead.length === 0) return null;
    return (
        <Form.Group className="mb-3" controlId={`${idPrefix}-reason`}>
            <Alert variant="warning" className="mb-2">
                {ahead.length} sökande står före i standardordningen: {ahead.map(e => getTenantName(e.tenantKey)).join(', ')}
            </Alert>
            <Form.Label>Anledning *</Form.Label>
            <Form.Control as="textarea" rows={2} value={reason} onChange={e => onReasonChange(e.target.value)} isInvalid={!!error} />
            <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        </Form.Group>
    );
};

export default DeviationNotice;
